import { createContext, useContext, useEffect, useState } from 'react';
import { loginAsGuest, type AuthState } from '../auth';

export interface AuthContextValue extends AuthState {
    retry: () => void;
}

export const AuthContext = createContext<AuthContextValue>({
    token: null,
    loading: true,
    error: null,
    retry: () => {},
});

export function useAuth(): AuthContextValue {
    return useContext(AuthContext);
}

/** Hook for the AuthProvider to manage guest auth state. */
export function useAuthState(): AuthContextValue {
    const [state, setState] = useState<AuthState>({
        token: null,
        loading: true,
        error: null,
    });

    const doLogin = () => {
        setState({ token: null, loading: true, error: null });
        loginAsGuest()
            .then(token => setState({ token, loading: false, error: null }))
            .catch(err => setState({ token: null, loading: false, error: err.message }));
    };

    useEffect(() => { doLogin(); }, []);

    return { ...state, retry: doLogin };
}
